import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const NotebookFileView = styled.div`
    padding: 20px 0px;
    border: 1px solid #dadada;


    .ipynb-renderer-root div.rendered_html * {
        font-family: var(--font-bwseido-raw) !important;
        color: black !important
    }
`